import { DataSourceValidationEvent, LookupModelSearchEvent, ValidationResult } from "@mcleod/components";
import { AutogenLayoutDriverExpirationDateReport } from "./autogen/AutogenLayoutDriverExpirationDateReport";

export class DriverExpirationDateReport extends AutogenLayoutDriverExpirationDateReport {

     override onLoad(){
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        this.textboxExpiringIn.text = "30";
    }

    textboxFleetBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_driver = "Y";
    }

    textboxTerminalBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_terminal = "Y";
    }

    sourceDriverExpirationDateOnValidate(event: DataSourceValidationEvent) {
        const result = this.validateExpireTypes();
        if (result) {
            event.validationResults.push(result);
        }
    }

    public validateExpireTypes(): ValidationResult {
        if(!this.checkboxDriverLicense.checked && !this.checkHM126.checked && !this.checkboxHazMat.checked
            && !this.checkMVRDate.checked && !this.checkboxMedicalCertificate.checked && !this.checkboxPhysicalDue.checked
            && !this.checkboxSecurityAwareness.checked) {
                const message = "Please select at least one expiration type.";
                return {
                    isValid: false,
                    validationMessage: message,
                    caption: message,
                    component: this.checkboxDriverLicense
                };
        }

    }

}